<template>
    <div name="address-card" class="address-card">
        <div class="space-between">
            <span>{{ addressNickname }}</span>
            <div class="button" @click="updateAddress">변경하기</div>
        </div>
        <span class="detail-text">{{ address }} <br> {{ detailAddress }} <span style="width: 100%;word-wrap: break-word;  overflow-wrap: break-word; " v-if="addressDescription !== null && addressDescription !== ''">({{ addressDescription }})</span></span>
    </div>
</template>

<script>
export default {
    name: 'addressCard',
    props: ['address', 'detailAddress', 'addressNickname', 'zipCode', 'addressDescription'],
    methods: {
        updateAddress: function()
        {
            this.$emit('updateAddress')
        }
    }
}
</script>

<style scoped>
    .address-card {
        width: 100%;
        padding: 16px;
        box-sizing: border-box;
        border-radius: 6px;
        border: 1px solid var(--gray-30-stroke-disabled, #E8EAEE);
        background: var(--Gray-00, #FFF);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
    }
    .space-between {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 100% */
    }
    .button {
        display: flex;
        padding: 8px;
        align-items: flex-start;
        box-sizing: border-box;
        border-radius: 100px;
        background: var(--Gray-20, #F3F5F8);
        cursor: pointer;
    }
    .detail-text {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px; /* 122.222% */
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/AddressCard.vue